import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('PaymentCard');

const propTypes = {
    ariaLabel: PropTypes.string,
    as: PropTypes.string,
    card: PropTypes.string,
    className: PropTypes.string,
};

const PaymentCard = ({ ariaLabel, as: Tag = 'li', card, className }) => (
    <Tag aria-label={ariaLabel || card} className={bem(card?.replace('_', '').toLowerCase(), null, className)} {...(Tag === 'div' && { role: 'img' })} />
);

PaymentCard.propTypes = propTypes;

export default PaymentCard;
